<template>
  <v-container fluid class="justify-center">
    <v-row class="justify-center">
      <v-col cols="12">
        <v-card class="justify-center">
          <v-card-title class="justify-center">Live Elections</v-card-title>
          <v-card-text class="justify-center align-center" v-if="poll.length>0">
            <v-stepper flat v-model="e1" alt-labels>
              <v-stepper-header>
                <template v-for="(item,n) in poll">
                  <v-stepper-step
                      :key="`${n+1}-step`"
                      :complete="e1 > n+1"
                      :step="n+1"
                  >
                    Question {{ n + 1 }}
                  </v-stepper-step>

                  <v-divider
                      v-if="n+1 !== poll"
                      :key="n+1"
                  ></v-divider>

                </template>
                <v-stepper-step
                    :key="`${steps+1}-step`"
                    :complete="e1 > steps+1"
                    :step="steps+1"
                >
                  Answers
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content
                    v-for="(step,n) in poll"
                    :key="`${n+1}-content`"
                    :step="n+1"
                >
                  <v-card
                      flat
                      class="mb-6"
                      color="lighten-1"
                      height="auto"
                  >
                    <h3>{{ step.question }}</h3>
                    <v-form ref="form" lazy-validation>
                      <v-radio-group v-model="radioGroup[n]" :rules="[v => !!v || 'Answer is required']">
                        <v-radio
                            v-for="(item,j) in step.poll_options"
                            :key="j"
                            :label="item.option"
                            :value="{'item':item,'index':j}"
                        >
                          <template v-slot:label>
                            <v-avatar
                                size="80px"
                            >
                              <img
                                  alt="Avatar"
                                  :src="item.image"
                              >
                            </v-avatar>
                            <div class="ml-5 body-2">{{ item.option }}</div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-form>
                  </v-card>

                  <v-btn
                      color="primary"
                      @click="nextStep(n+1)"
                  >
                    Continue
                  </v-btn>

                  <v-btn text>
                    Cancel
                  </v-btn>
                </v-stepper-content>
                <v-stepper-content :step="steps+1">
                  <v-card
                      flat
                      class="mb-12"
                      color="lighten-1"
                  >
                    <v-card-text>
                      <v-row class="mt-6" v-if="radioGroup.length>0">
                        <v-col cols="12">My Answers
                          <v-divider/>
                        </v-col>
                        <v-col cols="12" v-for="(item,n) in poll" :key="item.id" >
                          <i>Question {{ n + 1 }}: {{ item.question }}</i>
                          <br/>
                          Your Answer:<br/><strong><h3> {{ getAnswer(radioGroup[n]) }}</h3></strong>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-divider class="ma-2"/>
                    <v-btn
                        color="primary mr-1"
                        @click="completePoll"
                    >
                      Complete Poll
                    </v-btn>

                    <v-btn text>
                      Cancel
                    </v-btn>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>

          </v-card-text>
          <v-card-text class="justify-center align-center text-center" v-else>
            <v-progress-circular size="70" color="red" indeterminate
                                 class="justify-center align-center text-center"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {getRequest, postRequest} from "@/api/apirepository";

export default {
  name: "PollQuestions",
  data() {
    return {
      e1: 1,
      radioGroup: [],
      pollDets: [],
      steps: 0,
      poll: []
    }
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
  },

  methods: {
    getAnswer(item) {
      if (typeof (item) == "object") {
        return item.item.option
      }

    },
    nextStep(n) {
      if (this.$refs.form[n - 1].validate()) {
        // console.log(n)
        // if (n === this.steps) {
        //   this.e1 = 1
        // } else {
        this.e1 = n + 1
        // }
      }
    },
    completePoll() {
      // if (this.$refs.form[n-1].validate()) {
      swal.fire('Votes', '', "success")
      // }
      postRequest('submitOnlinePoll', {
        data: this.radioGroup,
        pollId: this.pollDets.id,
        userId: localStorage.getItem('userId'),
      }).then(res => {
        swal.fire('Voted Successfully', '', 'success')
        this.$router.push({name: 'CheckPoll'})
      }).catch(e => {
        swal.fire('Error Occured', 'Something went wrong with your vote', "error")
        this.$router.push({name: 'CheckPoll'})
      })
    },
    getPoll() {
      getRequest('getPollByUser', {
        params: {
          userId: localStorage.getItem('userId'),
          userPhone: localStorage.getItem('userPhone'),
        }
      }).then(({data}) => {
        if (typeof (data) === 'object') {
          this.poll = data.questions;
          this.pollDets = data.poll;
          this.steps = data.questions.length;
        } else {
          if (data.includes('Register')) {
            swal.fire('Not a Voter', 'Please register as a Voter to participate in this polls', 'info')
            this.$router.push({name: 'CheckPoll'})
          } else if (data.includes('already')) {
            swal.fire('Already Voted', 'You can only vote once', 'info')
            this.$router.push({name: 'CheckPoll'})
          } else if (data.includes('eligible')) {
            swal.fire('No Poll', 'No active poll at this time. Try again Later', 'info')
            this.$router.push({name: 'CheckPoll'})
          }
        }

      }).catch(e => {
        console.log(e)
        swal.fire('Error', 'You dont qualify for a Poll', "error")
        this.$router.push({name: 'CheckPoll'})
      })
    }
  },
  created() {
    this.getPoll()
  }
}
</script>

<style scoped>

</style>